var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEducation = function SvgEducation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29,
    fill: "none",
    viewBox: "0 0 28 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.172 25.147h.098zh-.168zm10.232-7V12.25l-2.8 1.54v3.398c0 .43 0 .676-.013.888a7.1 7.1 0 0 1-6.658 6.658c-.247.015-.494.014-.755.013h-.348c-.26.001-.508.002-.755-.013a7.1 7.1 0 0 1-6.658-6.658 16 16 0 0 1-.013-.888v-3.394L3.23 12.049c-1.105-.608-1.105-2.197 0-2.804l10.004-5.5a1.6 1.6 0 0 1 1.542.001l9.995 5.499c.507.279.834.826.834 1.402v7.5a.6.6 0 0 1-1.2 0m-11.17-.6-5.63-3.093v2.693c0 .473 0 .683.01.856a5.9 5.9 0 0 0 5.534 5.533c.173.01.383.01.856.01s.683 0 .856-.01a5.9 5.9 0 0 0 5.533-5.533c.01-.173.011-.383.011-.856V14.45l-5.629 3.096a1.6 1.6 0 0 1-1.542 0m.77-12.855L3.17 10.647l10.834 5.955 10.825-5.955z",
    clipRule: "evenodd"
  })));
};
export default SvgEducation;